import { FontWeight, Heading, Text } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { LastNameInput } from '@Components/inputs/LastNameInput';
import { FirstNameInput } from '@Components/inputs/FirstNameInput';
import { RoutesMap } from '@Router/router.types';
import { getRouteOrdinal } from '@Router/router.types';
import { PhoneInput } from '@Components/inputs/Phone';
import { OnboardingFormFields } from '@Types/index.ts';
import { CurrentDate } from '@Components/CurrentDate/CurrentDate';

export type AccountantPersonalDetailsFormType = {
  [OnboardingFormFields.FIRST_NAME]: string;
  [OnboardingFormFields.LAST_NAME]: string;
  [OnboardingFormFields.PHONE_NUMBER]: string;
};

export const AccountantPersonalDetailsForm = () => {
  const { t } = useTranslation('inviteTeamMember');
  const baseTabIndex = getRouteOrdinal(RoutesMap.INVITE_ACCOUNTANT_FORM);

  return (
    <div className='flex flex-col w-full mt-[24px]'>
      <div className='flex flex-row gap-[16px] w-full'>
        <div className='w-full '>
          <FirstNameInput disabled={false} tabIndex={baseTabIndex + 1} />
        </div>
        <div className='w-full '>
          <LastNameInput disabled={false} tabIndex={baseTabIndex + 2} />
        </div>
      </div>

      <PhoneInput tabIndex={baseTabIndex + 3} />

      <div>
        <CurrentDate label={t('accountantPersonalDetails.currentDate')} className='mb-[24px]' />

        <div className='bg-surface-primary-bw-01 rounded-[12px] p-[16px] outline outline-1 outline-outline-primary-bw-03'>
          <Heading.H9 fontWeight={FontWeight.MEDIUM} className='mb-[4px]'>
            {t('accountantPersonalDetails.authorizationTitle')}
          </Heading.H9>
          <Text.H10 className='text-text-main-secondary whitespace-pre-line'>
            {t('accountantPersonalDetails.authorizationText')}
          </Text.H10>
        </div>
      </div>
    </div>
  );
};
